<template>
  <v-img
    v-if="namespace === 'Home'"
    :height="$vuetify.breakpoint.xsOnly ? '100vh' : '70vh'"
    gradient="to top, rgba(255, 255, 255, .75), rgba(255, 255, 255, .75)"
    src="/static/photo-3.jpg"
  >
    <v-container
      fill-height
      fluid
      :px-12="$vuetify.breakpoint.mdAndUp"
    >
      <v-row align-center>
        <v-slide-x-transition appear>
          <v-col>
            <vue-typed-js
              :strings="['Hi, I\'m Harold IBOUANGA']"
              :show-cursor="true"
            >
              <h1
                class=" typing text-uppercase font-weight-bold mb-4"
                :class="[$vuetify.breakpoint.xsOnly ? 'display-1' : 'display-3']"
              />
            </vue-typed-js>
            <vue-typed-js
              :strings="['I\'m a Software Engineer']"
              :start-delay="3000"
              :show-cursor="false"
            >
              <div
                class="typing mb-4"
                :class="[$vuetify.breakpoint.xsOnly ? 'headline' : 'display-2 font-weight-light']"
              />
            </vue-typed-js>

            <vue-typed-js
              :strings="['Java developer for almost 4 years, passionate about web technologies, fintech and healthtech. I like clean code and beautiful application architecture.']"
              :start-delay="5000"
              :show-cursor="false"
              :type-speed="10"
            >
              <v-responsive
                max-width="600"
                class="mb-5"
              >
                <div class="typing" />
              </v-responsive>
            </vue-typed-js>

            <v-btn
              large
              class="px-5"
              color="primary"
              to="/contact-me"
            >
              Let's work together
            </v-btn>
          </v-col>
        </v-slide-x-transition>
      </v-row>
    </v-container>
  </v-img>

  <v-sheet
    v-else
    :min-height="$vuetify.breakpoint.smAndDown ? '45vh' : '300px'"
    color="grey lighten-3"
    height="20vh"
  >
    <v-container fill-height>
      <v-row
        align-content="center"
        justify="center"
        class="fill-height"
      >
        <v-col cols="12">
          <h1
            class="display-2 text-center"
            v-text="title"
          />
        </v-col>

        <v-breadcrumbs
          :items="breadcrumbs"
          class="grey--text pb-0 px-3"
        />
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
  import Vue from 'vue'
  import VueTypedJs from 'vue-typed-js'
  Vue.use(VueTypedJs)

  export default {
    computed: {
      breadcrumbs () {
        const home = { text: 'Home', to: '/' }

        switch (this.namespace) {
          case 'About': return [home, { text: 'About Me' }]
          case 'Contact': return [home, { text: 'Contact Me' }]
          case 'Work': return [home, { text: 'My Work' }]
          default: return []
        }
      },
      namespace () {
        return this.$route.name
      },
      title () {
        switch (this.namespace) {
          case 'About': return 'About Me'
          case 'Contact': return 'Contact Me'
          case 'Work': return 'My Work'
          default: return ''
        }
      }
    }
  }
</script>
